import React from 'react'
import { useAuth } from 'lib/auth'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import CoachEventDetails from './event-details-modal/coach-event-details'
import ConsumerEventDetails from './event-details-modal/consumer-event-details'

const useStyles = makeStyles({
  dialogPaper: {
    borderRadius: 12,
    maxHeight: 'calc(100vh - 64px)',
    // pgaCoachTheme sets PaperProps.style.overflow: 'hidden' inline, so the
    // paper cannot scroll. Keep it clipped and scroll DialogContent instead
    // so the hero stays pinned while long attendee lists remain reachable.
    overflow: 'hidden',
    '& .MuiDialogTitle-root': {
      flex: '0 0 auto',
    },
    '& .MuiDialogContent-root': {
      flex: '1 1 auto',
      minHeight: 0,
      overflowY: 'auto',
    },
  },
})

const WhichDetailsModal = props => {
  const { isConsumer } = useAuth()

  return isConsumer ? (
    <ConsumerEventDetails {...props} />
  ) : (
    <CoachEventDetails {...props} />
  )
}

const EventDetailsDialog = ({ isOpen, setIsOpen, event }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  return (
    <Dialog
      open={!!isOpen}
      onClose={() => setIsOpen(false)}
      fullScreen={isMobile}
      maxWidth="md"
      fullWidth
      classes={isMobile ? undefined : { paper: classes.dialogPaper }}
    >
      {isOpen ? (
        <WhichDetailsModal {...{ setIsOpen, event, view: isOpen }} />
      ) : null}
    </Dialog>
  )
}

export default EventDetailsDialog
